<mat-form-field class="input-container" appearance="outline">
  <mat-label data-testid="search-input-label">{{ inputLabel }}</mat-label>

  <input
    [attr.id]="id ? id + '-input' : null"
    data-testid="search-input"
    type="text"
    [placeholder]="placeholder"
    aria-label="Search"
    style="border: 1px solid red"
    matInput
    [value]="inputSearchValue"
    [matAutocomplete]="auto"
    (keydown.enter)="handleSearch()"
    (input)="onChangeSearch($event.target.value)"
    appInputRegex
    />
    <app-icon matPrefix [name]="'search'"></app-icon>

    @if (inputSearchValue) {
      <button
        [attr.id]="id ? id + '-clear-btn' : null"
        mat-icon-button
        matSuffix
        (click)="handleClearSearch()"
        >
        <mat-icon>close</mat-icon>
      </button>
    }

    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      @for (option of optionSearchListFiltered; track option; let i = $index) {
        <mat-option
          data-testid="autocomplete-option"
          [attr.id]="id ? id + '-option-' + i : null"
          [value]="inputSearchValue"
          (onSelectionChange)="onOptionSelectionChange($event, option)"
          >
          @if (layoutOpcaoTemplate) {
            <ng-container
              *ngTemplateOutlet="layoutOpcaoTemplate; context: { $implicit: option }" >
            </ng-container>
          } @else {
            {{ option }}
          }
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <app-button
    [id]="id ? id + '-btn' : undefined"
    [buttonStyle]="'danger'"
    size="large"
    (click)="handleSearch()"
    [disabled]="disabled"
    i18n="@@search"
    >
  Buscar
</app-button>

  <ng-content select="appSearchInputOptionTemplate"></ng-content>
